import React, { useEffect, useRef } from 'react';
import '../gMap/Gmap.css'
 
const GMap = (props) => {
    const googleMapRef = useRef(null);
    const googleMapInstance = useRef(null);
    var markerList = props.markerList ? props.markerList : []
    const taskLog = props.taskLog || [];
   
    // list of icons
    const iconList = {
      icon1: 'https://cdn4.iconfinder.com/data/icons/logos-brands-in-colors/150/google-maps-512.png',
      icon2: 'https://cdn2.iconfinder.com/data/icons/IconsLandVistaMapMarkersIconsDemo/256/MapMarker_Marker_Outside_Chartreuse.png',
      icon3: 'https://cdn1.iconfinder.com/data/icons/Map-Markers-Icons-Demo-PNG/256/Map-Marker-Ball-Right-Azure.png',
      icon4: 'https://cdn1.iconfinder.com/data/icons/Map-Markers-Icons-Demo-PNG/256/Map-Marker-Marker-Outside-Pink.png'
      
    }
   
    // list of the marker object along with icon
    useEffect(() => {
      googleMapInstance.current = initGoogleMap();
      var bounds = new window.google.maps.LatLngBounds();
      markerList.map(x => {
        const marker = createMarker(x);
        bounds.extend(marker.position);
      });
     googleMapInstance.current.fitBounds(bounds);
      google.maps.event.addListenerOnce(googleMapInstance.current, 'idle', () => {
    googleMapInstance.current.setZoom(17);
    });
    drawCompletedRoute();
    }, []);
   
   
    // initialize the google map
    const initGoogleMap = () => {
      return new window.google.maps.Map(googleMapRef.current, {});
  };
   
    // create marker on google map
    const createMarker = (markerObj) => new window.google.maps.Marker({
      position: { lat: markerObj.lat, lng: markerObj.lng },
      map: googleMapInstance.current,
      title: markerObj.title,
    //   label: {text:markerObj.title,
    //     fontSize: "15px",
    //     fontWeight: "bold",
    //     color:"#D22B2B",
    //     position: "absolute",
    //     },
        icon: {
        url: markerObj.icon,
        labelOrigin: new window.google.maps.Point(30, 60),
        // set marker width and height
        scaledSize: new window.google.maps.Size(50, 50)
      }
    });
const drawCompletedRoute = async () => {
  if (!taskLog || taskLog.length === 0) return;

  var startLog = taskLog.find(
    (log) => log.taskStatus === 5 && log.latitude != null && log.longitude != null
  );

  var completedLogs = taskLog.filter(
    (log) => [8, 9, 10].includes(log.taskStatus) && log.latitude != null && log.longitude != null
  );

  var completedLog = completedLogs[completedLogs.length - 1];

  if (!startLog || !completedLog) return;

  if (
    Number(startLog.latitude) === Number(completedLog.latitude) &&
    Number(startLog.longitude) === Number(completedLog.longitude)
  ) return;

  try {
    // CHANGED: use Route instead of RoutesService
    var { Route } = await window.google.maps.importLibrary("routes");

    var result = await Route.computeRoutes({
      origin: new window.google.maps.LatLng(Number(startLog.latitude), Number(startLog.longitude)),
      destination: new window.google.maps.LatLng(Number(completedLog.latitude), Number(completedLog.longitude)),
      travelMode: window.google.maps.TravelMode.DRIVING,
      fields: ["*"]
    });

    var route = result.routes[0];
    if (!route) return;

    // CHANGED: path is directly on route, each point has lat() and lng() methods
    var path = route.path.map(point => ({
  lat: point.lat,
  lng: point.lng
}));

    new window.google.maps.Polyline({
      path,
      map: googleMapInstance.current,
      strokeColor: "#4285F4",
      strokeWeight: 8,
      strokeOpacity: 4,
    });

  } catch (error) {
    console.error("Routes API error:", error);
  }
};
 
  return <div
    ref={googleMapRef}
    style={{ width: '100%', height: '100%' }}
  />
}
 
export default GMap;